/** Libellés et styles des statuts du module YouTube Studio (UI admin). */

import type {
  YoutubeVideoStatus,
  YoutubeJobStep,
  SocialPlatform,
  SocialPrivacy,
} from '@jeraisonne/db/schemas/youtube';

export const VIDEO_STATUS_LABEL: Record<YoutubeVideoStatus, string> = {
  draft: 'Brouillon',
  queued: 'En file',
  rendering: 'Capture en cours',
  encoding: 'Composition',
  uploading: 'Mise en ligne',
  published: 'Publiée',
  failed: 'Échec',
};

export const VIDEO_STATUS_CLS: Record<YoutubeVideoStatus, string> = {
  draft: 'bg-ink-100 text-ink-500 border-ink-200',
  queued: 'bg-amber-50 text-amber-700 border-amber-200',
  rendering: 'bg-primary-50 text-primary-700 border-primary-200',
  encoding: 'bg-primary-50 text-primary-700 border-primary-200',
  uploading: 'bg-primary-50 text-primary-700 border-primary-200',
  published: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  failed: 'bg-accent-50 text-accent-700 border-accent-200',
};

/** Une vidéo en cours de traitement (barre de progression à afficher). */
export function videoIsProcessing(status: YoutubeVideoStatus): boolean {
  return (
    status === 'queued' || status === 'rendering' || status === 'encoding' || status === 'uploading'
  );
}

export const JOB_STEP_LABEL: Record<YoutubeJobStep, string> = {
  capturing: 'Capture du player',
  composing: 'Composition vidéo',
  thumbnailing: 'Génération de la miniature',
  uploading: 'Upload',
  finalizing: 'Finalisation',
};

export function jobStepLabel(step: YoutubeJobStep | null | undefined): string | null {
  if (!step) return null;
  return JOB_STEP_LABEL[step] ?? step;
}

/** Avancement indicatif (%) pour la barre de progression, par étape. */
export const JOB_STEP_PROGRESS: Record<YoutubeJobStep, number> = {
  capturing: 20,
  composing: 50,
  thumbnailing: 65,
  uploading: 85,
  finalizing: 95,
};

export const PLATFORM_LABEL: Record<SocialPlatform, string> = {
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram_reels: 'Instagram Reels',
  facebook_reels: 'Facebook Reels',
  // Réseaux du blog (publication feed/page, migration 0131).
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  instagram: 'Instagram',
};

export const PRIVACY_LABEL: Record<SocialPrivacy, string> = {
  private: 'Privée',
  unlisted: 'Non répertoriée',
  public: 'Publique',
};
